var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-date-picker',{attrs:{"mode":"year","valueFormat":"YYYY","format":"YYYY","placeholder":"选择年份","open":_vm.open,"value":_vm.value1},on:{"panelChange":_vm.panelChange,"openChange":_vm.openChange}})}
var staticRenderFns = []

export { render, staticRenderFns }